'use client';

import React, { Suspense, createContext, useContext, useState } from 'react';
import { GalleryPlaceholder } from './GalleryPlaceholder';
import GalleryModal from './media/GalleryModal';
import * as stylex from '@stylexjs/stylex';
export const GalleryContext = createContext<(index: number) => void>(() => {});
export function OpenGallery({
  children,
  initalIndex
}) {
  const openWithIndex = useContext(GalleryContext);
  return <div onClick={() => {
    openWithIndex(initalIndex);
  }} className="x1ypdohk">
      {children}
    </div>;
}
export function Gallery({
  children,
  images,
  id,
  title
}) {
  const [showImageGalleryModalWithInitialIndex, setShowImageGalleryModalWithInitialIndex] = useState<number | null>(null);
  return <GalleryContext.Provider value={setShowImageGalleryModalWithInitialIndex}>
      <Suspense fallback={<GalleryPlaceholder />}>
        {showImageGalleryModalWithInitialIndex !== null && <GalleryModal isOpen={true} onRequestClose={() => {
        setShowImageGalleryModalWithInitialIndex(null);
      }} initialSlide={showImageGalleryModalWithInitialIndex} images={images} title={title} id={id} />}
      </Suspense>
      {children}
    </GalleryContext.Provider>;
}